import React, { useContext, useState } from 'react';

type FullscreenContextTypes = {
  isFullscreen: boolean;
  toggleFullscreen: () => void;
  setIsFullscreen: React.Dispatch<React.SetStateAction<boolean>>;
};

type FullscreenProviderPropsTypes = {
  children: React.ReactNode;
};

const FullscreenContext = React.createContext<FullscreenContextTypes>({} as FullscreenContextTypes);

export const useFullscreen = () => useContext(FullscreenContext);

export const FullscreenProvider = ({ children }: FullscreenProviderPropsTypes) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    setIsFullscreen((prevValue) => !prevValue);
  };

  return (
    <FullscreenContext.Provider
      value={{
        isFullscreen,
        toggleFullscreen,
        setIsFullscreen,
      }}
    >
      {children}
    </FullscreenContext.Provider>
  );
};
